module.exports = __webpack_public_path__ + "img/banner.e4e0a261.gif";